import { LineItemFragment, WasteClassification } from "generated-graphql/graphql";
import { OmnisearchGridColDef } from "hooks/useOmnisearchDatagrid";

import { prettyPrintWasteClassification } from "../Facilities/Facility/prettyPrintWasteClassification";
import { WasteClassificationChip } from "../WasteClassificationChip";

export function buildLineItemClassificationColumn<
  Row extends Pick<LineItemFragment, "classification">,
>(): OmnisearchGridColDef<Row> {
  return {
    field: "classification",
    headerName: "Classification",
    minWidth: 170,
    flex: 1,
    sortable: false,
    filterKeyType: "enumAutocomplete",
    enumValues: Object.values(WasteClassification),
    enumPresentationFunction: prettyPrintWasteClassification,
    valueFormatter: (_, row) => prettyPrintWasteClassification(row.classification),
    renderCell: ({ row }) => <WasteClassificationChip classification={row.classification} />,
  };
}
